<div class="flex w-full profile--user-row">
  <app-user-common-info
    [user]="user()!"
    [registeredDate]="profileResource.value()?.profile?.registered"
  ></app-user-common-info>
</div>
<div class="divider horizontal w-full"></div>

<div class="profile--content">
  @if (!profileResource.error()) { @if (profileResource.value()?.isPrivate) {

  <div animate.enter="animate-fade-in" class="profile--hidden">
    <p>User has hidden their stats.</p>
  </div>
  } @else {
  <div animate.enter="animate-fade-in" class="profile--stats">
    @if (profileResource.isLoading()) { @for (item of [1, 2, 3, 4]; track
    $index) {
    <div
      class="skeleton-animation w-full h-full flex items-center justify-center rounded-4"
      style="background: var(--gray-24); height: 60px"
    ></div>

    } } @else { @for (stat of stats(); track stat.label) {
    <app-card animate.enter="animate-fade-in" [color]="stat.color">
      <ng-container card-icon>
        @if (stat.icon.endsWith('.svg')) {
        <svg-icon
          class="s-20 flex items-center justify-center"
          [src]="stat.icon"
        ></svg-icon>
        } @else {
        <img
          class="s-30 flex items-center justify-center"
          loading="lazy"
          [src]="stat.icon"
        />
        }
      </ng-container>

      @if (typeof stat.value === 'number') {
      <div card-value class="flex items-center gap-4">
        <svg-icon
          class="flex items-center justify-center s-12"
          src="assets/icons/core/price.svg"
        ></svg-icon>
        <span
          [countUp]="+stat.value"
          [options]="countUpOptions"
          [reanimateOnClick]="false"
        ></span>
      </div>
      } @else {
      <span card-value class="flex items-center gap-4">
        {{ stat.value }}
        @if (stat.subValue) {
        <span style="color: var(--gray); font-size: 11px; font-weight: 400">{{ stat.subValue }}</span>
        }
      </span>
      }
      <span card-label>{{ stat.label }}</span>
    </app-card>
    } }
  </div>
  @if (profileResource.isLoading()) {
  <div class="flex flex-col" style="gap: 2px">
    <div class="w-full flex items-center justify-end">
      <span
        class="h-22 skeleton-animation rounded-4"
        style="background: var(--gray-24); width: 120px"
      ></span>
    </div>
    <div class="profile--wagers">
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,]; track $index) {
      <div
        class="profile--wager skeleton-animation w-full h-full flex items-center justify-center rounded-4"
        style="background: var(--gray-24); height: 100%"
      ></div>
      }
    </div>
  </div>
  } @else {
  <div animate.enter="animate-fade-in" class="flex flex-col" style="gap: 2px">
    <span
      class="typography-small w-full flex items-center justify-end"
      style="color: var(--gray)"
    >
      Last 2 weeks
    </span>
    <div class="profile--wagers">
      @for (wager of wagers(); track wager.title) {
      <div
        class="profile--wager box-white-04 hover padding-x-12 flex items-center"
      >
        <span class="profile--wager-title">{{ wager.title }}</span>
        <div class="flex items-center gap-4">
          <svg-icon
            class="flex items-center justify-center s-12"
            src="assets/icons/core/price.svg"
          ></svg-icon>
          <span
            class="profile--wager-value"
            [countUp]="wager.value"
            [options]="countUpOptions"
            [reanimateOnClick]="false"
          ></span>
        </div>
      </div>
      }
    </div>
  </div>
  } @if (profileResource.isLoading()) {
  <div class="flex flex-col" style="gap: 2px">
    <div class="w-full flex items-center justify-end">
      <span
        class="h-22 skeleton-animation rounded-4"
        style="background: var(--gray-24); width: 120px"
      ></span>
    </div>
    <div
      class="profile--rewards skeleton-animation w-full h-full flex items-center justify-center rounded-4"
      style="background: var(--gray-24); height: 100%; min-height: 126px"
    ></div>
  </div>
  } @else {
  <div animate.enter="animate-fade-in" class="flex flex-col" style="gap: 2px">
    <span
      class="typography-small w-full flex items-center justify-end"
      style="color: var(--gray)"
    >
      Last 2 weeks
    </span>
    <div class="profile--rewards box-white-04 padding-x-12 w-full">
      <p class="profile--rewards-title">Rewards</p>
      <div class="profile--rewards-list">
        @for (reward of rewards(); track reward.name) {
        <div class="profile--rewards-item">
          <span class="profile--rewards-item-title"
            >{{ reward.name }} Claimed</span
          >
          <span class="profile--rewards-item-divider"></span>
          <div class="flex items-center gap-4">
            <svg-icon
              class="flex items-center justify-center s-12"
              src="assets/icons/core/skins.svg"
            ></svg-icon>
            <span
              class="profile--rewards-item-value"
              [countUp]="reward.value"
              [options]="countUpOptions"
              [reanimateOnClick]="false"
            ></span>
          </div>
        </div>
        @if ($index === 4) {

        <div class="divider vertical h-full"></div>
        } }
      </div>
    </div>
  </div>
  } } } @else {
  <div
    animate.enter="animate-fade-in" animate.leave="animate-fade-out"
    style="text-align: center"
    class="flex flex-col gap-4 items-center justify-center w-full h-full"
  >
    <p class="flex flex-col gap-2 w-full justify-center items-center">
      <span style="max-width: 80%">
        {{ profileResource.error() }}
      </span>
      <span style="max-width: 80%">
        Something went wrong, please try reload or reopen the popup.
      </span>
    </p>
    <button
      class="button button--style-primary h-32 padding-x-12 rounded-4"
      (click)="profileResource.reload()"
    >
      Reload
    </button>
  </div>
  }
</div>
